import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {BaseApiTemplateService} from '../../shared/base-api-template-service.model';
import {Core2Config} from '../../shared/core2Config';
import {CompBranchLocationEntityLinkContainerModel} from '../../../../../../models/aggregates/erp/comp-branch-location-entity-link';


@Injectable({
  providedIn: 'root'
})
export class CompBranchLocationEntityLinkService extends BaseApiTemplateService<CompBranchLocationEntityLinkContainerModel> {

  readonly url = Core2Config.DOMAIN_TEST_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + 'comp-branch-location-entity-links';

  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_TEST_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + 'comp-branch-location-entity-links/' + Core2Config.BACKOFFICE_EP_SUFFIX;
    this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + 'comp-branch-location-entity-links/' + Core2Config.BACKOFFICE_EP_SUFFIX;
    this.httpClient = http;
  }
}
